import { render } from "./Products.vue?vue&type=template&id=69b2025c&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=69b2025c&scoped=true&lang=css"
import "./Products.vue?vue&type=style&index=1&id=69b2025c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b2025c"]])

export default __exports__